// import { useMemo } from "react";
// import { useQuery } from "urql";
// import dummyData from "../objs/_SameObjs/UserList/DummyData.json";
// // import { UserStatusesQry } from "api/queries";
// export const useUserRole = (pause = false) => {
//   //   const [{ data }] = useQuery({
//   //     query: UserStatusesQry,
//   //     context: useMemo(() => ({ requestPolicy: "cache-first" }), []),
//   //     pause,
//   //   });
//   const { role } = dummyData || {};
//   return role;
// };

type RoleOption = {
  value: string;
  label: string;
};

// TODO: implement useUserRole
export const useUserRole = (): RoleOption[] | null => {
  return null;
};
